{
  "de": {
    "select": {
      "actions": {
        "clear": "Leeren",
        "filterProject": "Nach Projekt filtern",
        "filterUnit": "Nach Einheit filtern",
        "noResults": "Keine Ergebnisse",
        "noResultsFor": "Keine Ergebnisse für {search}",
        "reset": "Zurücksetzen",
        "selectCategory": "Kategorie auswählen",
        "selectUnit": "Einheit auswählen",
        "setToday": "Heute",
        "startTyping": "Zum Suchen tippen"
      },
      "groups": {
        "customers": "Kunden",
        "employees": "Teammitglieder"
      },
      "labels": {
        "allUnits": "Alle Einheiten",
        "contact": "Kontakt",
        "without": "Ohne",
        "withoutContact": "Ohne Ansprechpartner"
      },
      "placeholders": {
        "contact": "Person suchen oder „ohne“ wählen..."
      }
    }
  }
}
